/*=========================================================================================
  File Name: moduleDevice.js
  Description: Device Module
==========================================================================================*/


import state from './moduleDeviceState.js'
import mutations from './moduleDeviceMutations.js'
import actions from './moduleDeviceActions.js'
import getters from './moduleDeviceGetters.js'

export default {
  deviceEnableList: [
    {value:'0', label:'Запрещен', color:'warning', tag:'disabled'},
    {value:'1', label:'Разрешен', color:'success', tag:'enabled'},
  ],
  deviceActivateList: [
    {value:'0', label:'Не активирован', color:'danger', tag:'disactivated'},
    {value:'1', label:'Активирован', color:'success', tag:'activated'},
  ],
  deviceConnectList: [
    {value:'0', label:'Не в сети', color:'danger', tag:'offline'},
    {value:'1', label:'В сети', color:'success', tag:'online'},
  ],
  deviceTypeList: [
    {value:'0', label:'nexus', color:'', tag:'nexus'},
    {value:'1', label:'gt06', color:'', tag:'gt06'},
    {value:'2', label:'watch', color:'', tag:'watch'},
    {value:'3', label:'km01', color:'', tag:'km01'},
    {value:'4', label:'km02', color:'', tag:'km02'},
    {value:'5', label:'gw01', color:'', tag:'gw01'},
    {value:'6', label:'flex', color:'', tag:'flex'},
    {value:'7', label:'ot2', color:'', tag:'ot2'},
    {value:'8', label:'a5e', color:'', tag:'a5e'},
    {value:'9', label:'t131a', color:'', tag:'t131a'},
    {value:'10', label:'a5c', color:'', tag:'a5c'},
    {value:'11', label:'galileosky_obd', color:'', tag:'galileosky_obd'},
    {value:'12', label:'lk720', color:'', tag:'lk720'},
    {value:'13', label:'t6h', color:'', tag:'t6h'},
    {value:'14', label:'14', color:'', tag:'14'},
    {value:'15', label:'15', color:'', tag:'15'},
    {value:'16', label:'16', color:'', tag:'16'},
    {value:'17', label:'a5e_2', color:'', tag:'a5e_2'},
    {value:'18', label:'18', color:'', tag:'18'},
  ],

  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
